import React, { useState, useReducer, useMemo, useEffect } from 'react'
import { Segment, Form, Header, Input, Icon, Table } from 'semantic-ui-react'
import InputMask from 'react-input-mask'
import { DateTime } from 'luxon'
import { toast } from 'react-toastify'
import request from 'services/http'
import { finalize, tap } from 'rxjs/operators'
import { useSubscription } from 'utils'
import TabelaExtratoResumo from './TabelaExtratoResumo'
import history from 'services/history'

const initialFormValues = {
    restaurante: '',
    dataInicio: '',
    dataFim: ''
}

function formReducer(state, action) {
    if ('reset' in action)
        return initialFormValues
    if (!('payload' in action))
        return state
    return { ...state, ...action.payload }
}

export default function FormularioExtratoResumo(props) {

    const [form, setForm] = useReducer(formReducer, initialFormValues)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [dados, setDados] = useState([])
    const [dateId, setDateId] = useState(null)
    const [restOptions,] = useState([
        { text: 'Restaurante Dom Pedro 1', value: '01' },
        { text: 'Restaurante Dom Pedro Atibaia', value: '04' },
        { text: 'Hotel Central', value: '08' },
    ])

     //GET RELATORIO
     const submitRelatorio$ = useMemo(() => request({
        url: '/movimentacao/extrato-resumo',
        method: 'GET',
        params: { ...form, ...dateId }
    }).pipe(
        tap(({ response }) => {
            if (response.data.length <= 0) {
                toast.error('Dados não encontrados.')
                return
            } else {
                setDados(response.data)
            }
        }),
        finalize(() => setIsSubmitting(false))
    ), [form, dateId])
    useSubscription(submitRelatorio$, isSubmitting)

    function handleChangeSelect(_, { name, value }) {
        setForm({ payload: { [name]: value } })
    }

    function handleChange(event) {
        let name, value
        [name, value] = [event.target.name, event.target.value]
        setForm({ payload: { [name]: value } })
    }

    function handleSubmit() {
        if (!(!!form.dataInicio) || !(!!form.dataFim)) {
            toast.error('Por favor, informe as datas corretamente antes de prosseguir.')
            return
        } else {
            let idDataIni = DateTime.fromFormat(form.dataInicio, 'dd/MM/yyyy').toFormat('yyMMdd');
            let idDataFim = DateTime.fromFormat(form.dataFim, 'dd/MM/yyyy').toFormat('yyMMdd');
            setDateId({
                de: idDataIni,
                ate: idDataFim
            })
            history.push(`${props.path}?rest=${form.restaurante}&de=${idDataIni}&ate=${idDataFim}`)
        }
    }

    useEffect(() => {
        const emp = new URL(window.location).searchParams.get('emp')
        const dataDe = new URL(window.location).searchParams.get('de')
        const dataAte = new URL(window.location).searchParams.get('ate')
        if (emp && dataDe && dataAte) {
            handleSubmit()
        }
        // eslint-disable-next-line
    }, [props.location.search])

    return (
        <div className="col d-flex align-items-center flex-column">
            <Segment basic textAlign='left' style={{ width: '100%', padding: '10px 0px' }}>
                <Form size={'tiny'} onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Select
                            width='5'
                            label={
                                <Header as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Restaurante</Header>
                            }
                            options={restOptions}
                            search
                            selectOnBlur={false}
                            placeholder='Selecionar Restaurante'
                            name='restaurante'
                            value={form.restaurante}
                            onChange={handleChangeSelect}
                        />
                        <Form.Field width='4'>
                            <Header floated='left' as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Data</Header>
                            <Header floated='right' as='h5' style={{ margin: 0, marginBottom: 5, color: 'white' }}>-</Header>
                            <Input
                                children={
                                    <InputMask mask="99/99/9999" placeholder='Inicial' value={form.dataInicio} name='dataInicio' onChange={handleChange} />
                                }
                            />
                        </Form.Field>
                        <Form.Field width='4'>
                            <Header floated='right' as='h5' style={{ margin: 0, marginBottom: 5, color: 'white' }}>-</Header>
                            <Input
                                children={
                                    <InputMask mask="99/99/9999" placeholder='Final' value={form.dataFim} name='dataFim' onChange={handleChange} />
                                }
                            />
                        </Form.Field>
                        <Form.Button label={'\u00A0'} floated='right' width='2' icon title='Limpar Campos' type='button' onClick={() => setForm({ reset: true })}>
                            <Icon name='trash' />
                        </Form.Button>
                        <Form.Button label={'\u00A0'} disabled={isSubmitting} floated='right' icon labelPosition='left' color='vk'>
                            <Icon name='arrow right' />
                            Enviar
                        </Form.Button>
                    </Form.Group>
                </Form>

                <Segment loading={isSubmitting} basic={true} style={{ margin: 0, padding: '0px 0px', marginBottom: '10px' }} textAlign='center'>
                    {dados.length > 0 ? (
                        <TabelaExtratoResumo dados={dados} form={form} />
                    ) :
                        <Table color='grey' size='small' singleLine textAlign='center' compact='very'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Data</Table.HeaderCell>
                                    <Table.HeaderCell>Nº Controle</Table.HeaderCell>
                                    <Table.HeaderCell>Descrição</Table.HeaderCell>
                                    <Table.HeaderCell>Valor</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell colSpan='5' style={{ height: '45vh' }}>
                                        Preencha os campos acima para fazer uma busca!
                            </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    }
                </Segment>
            </Segment>
        </div>
    )
}